import React, { useState, useEffect, useRef, useCallback } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Dropdown from "../../Components/CustomDropdown/customdropdown";
import ViewAccessRequestPopup from "./view-access-request-details";
import { setInvestmentId } from "../../Redux/store/investmentId.js";
import { useDispatch } from "react-redux";

const InspecieTransferRequest = () => {
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, settotalCount] = useState(0);
  const [totalPages, settotalPages] = useState(0);
  const [showRecords, setShowRecords] = useState(10);
  const [showRecordsAccess, setShowRecordsAccess] = useState(10);
  const [currentPageAccess, setCurrentPageAccess] = useState(1);
  const [totalCountAccess, settotalCountAccess] = useState(0);
  const [totalPagesAccess, settotalPagesAccess] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingAccess, setIsLoadingAccess] = useState(false);

  const [searchQuery, setSearchQuery] = useState("");
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [isPopupStockOpen, setIsPopupStockOpen] = useState(false);
  const [isPopupStockTransferOpen, setIsPopupStockTransferOpen] =
    useState(false);
  const [searchQueryAccess, setSearchQueryAccess] = useState("");

  const [changeStatus, setChangeStatus] = useState("");
  const dispatch = useDispatch();

  const navigate = useNavigate();
  const location = useLocation();
  const [isLoadingPortfolio, setIsLoadingPortfolio] = useState(false);
  const [sortKey, setSortKey] = useState(null);
  const [actionRowId, setActionRowId] = useState(null);

  const [sortAsc, setSortAsc] = useState(true);
  const [preSelectedFilter, setpreSelectedFilter] = useState({
    value: 10,
    label: "10",
  });
  const [preSelectedFilterAccess, setpreSelectedFilterAccess] = useState({
    value: 10,
    label: "10",
  });
  const filterOptions = [
    { value: 10, label: "10" },
    { value: 20, label: "20" },
    { value: 30, label: "30" },
    { value: 50, label: "50" },
  ];
  const [portfolioAccounttableData, setPortfolioAccounttableData] = useState([
    {
      date: "01/05/2025",
      hin_number: "552522",
      customer_name: "John Mayer",
      stocks: "10",
      strategies: "5",
      id: 1,
      status: "pending",
    },
    {
      date: "01/05/2025",
      hin_number: "552522",
      customer_name: "John Mayer",
      stocks: "6",
      strategies: "5",
      id: 2,
      status: "approved",
    },
  ]);
  const portfolioAccountheaders = [
    { label: "Date", key: "date" },
    { label: "HIN", key: "hin" },
    { label: "Customer Name", key: "name" },
    { label: "Stocks", key: "" },
    { label: "Matched Strategies", key: "Matched" },
  ];
  const portfolioRequestheaders = [
    { label: "Date", key: "date" },
    { label: "HIN", key: "hin" },
    { label: "Customer Name", key: "name" },
    { label: "Portfolio Name", key: "name" },
    { label: "Stocks", key: "" },
    { label: "Request Status", key: "" },
  ];
  const handleSort = (key) => {
    if (sortKey === key) {
      // Toggle sorting direction
      setSortAsc((prev) => !prev);
    } else {
      setSortKey(key);
      setSortAsc(true);
    }

    // Optional: You can also sort data directly here if needed
  };
  const handleshowRecord = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setShowRecords(parseInt(selectedOption.value));
    setCurrentPage(1);
  };
  const handleshowRecordAccess = (selectedOption) => {
    console.log("Selected Option:", selectedOption);
    setShowRecordsAccess(parseInt(selectedOption.value));
    setCurrentPageAccess(1);
  };
  return (
    <div className="lg:min-w-[78vw] lg:max-w-[80vw] pt-0">
      {loading && (
        <div className="fixed top-0 left-0 w-full h-full flex justify-center items-center bg-black bg-opacity-50 z-[999]">
          <div className="w-12 h-12 border-4 border-white border-t-transparent rounded-full animate-spin"></div>
        </div>
      )}
      <div className="font-medium bg-white mt-6 p-4 rounded-xl shadow-sm border border-gray-200 text-sm text-gray-900">
        {/* Header Section */}
        <div className="flex flex-col md:flex-row md:items-center justify-between mb-4 gap-4">
          <h3 className="text-base font-semibold text-black flex items-center gap-2">
            {/* Replace with any SVG above */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-6 h-6 text-black"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M3 7l9-4 9 4-9 4-9-4zm0 6l9 4 9-4m-9 4v5"
              />
            </svg>
            Inspecie Transfer Request
          </h3>

          <div className="flex flex-col sm:flex-row sm:items-center gap-3">
            {/* Show Records */}
            <div className="flex items-center gap-2">
              <span className="text-gray-600">Show</span>
              <Dropdown
                label=""
                options={filterOptions}
                preselectedValue={preSelectedFilter}
                onSelect={handleshowRecord}
              />
            </div>

            {/* Search */}
            <div className="relative w-full sm:w-auto">
              <input
                type="text"
                className="pl-9 pr-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-2 focus:ring-black focus:outline-none w-full sm:w-60 text-sm"
                placeholder="Search..."
                value={searchQuery}
                onChange={(e) => {
                  setCurrentPage(1);
                  setSearchQuery(e.target.value);
                }}
              />
              <img
                src="/search-normal.svg"
                alt="Search"
                className="absolute left-3 top-2 w-4 h-4 text-gray-400"
              />
            </div>
          </div>
        </div>

        {/* Table */}
        <div className="overflow-x-auto">
          <table className="min-w-full border-separate border-spacing-y-1 text-sm">
            <thead className="bg-gray-100 text-gray-700">
              <tr>
                {portfolioAccountheaders.map((header) => (
                  <th
                    key={header.label}
                    onClick={() => handleSort(header.key)}
                    className="px-4 py-2 text-left font-medium cursor-pointer whitespace-nowrap"
                  >
                    <div className="flex items-center space-x-1">
                      <span>{header.label}</span>
                      {header.key != "" && (
                        <img src="/sort.svg" alt="Icon" class="w-4 h-4 ml-2" />
                      )}
                    </div>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {isLoadingPortfolio ? (
                [...Array(5)].map((_, i) => (
                  <tr
                    key={i}
                    className="rounded border border-gray-100 bg-white"
                  >
                    {[...Array(4)].map((_, j) => (
                      <td key={j} className="px-4 py-3">
                        <div className="h-3 bg-gray-200 rounded animate-pulse"></div>
                      </td>
                    ))}
                  </tr>
                ))
              ) : portfolioAccounttableData.length > 0 ? (
                portfolioAccounttableData.map((row, index) => (
                  <tr
                    key={index}
                    className={`transition-colors border border-gray-100 ${
                      index % 2 === 0 ? "bg-white" : "bg-gray-50"
                    } hover:bg-indigo-50`}
                  >
                    <td className="px-4 py-3 whitespace-nowrap">{row.date}</td>
                    <td className="px-4 py-3 whitespace-nowrap">
                      {row.hin_number}
                    </td>
                    <td className="px-4 py-3 whitespace-nowrap">
                      {row.customer_name}
                    </td>
                    <td
                      onClick={(e) => {
                        e.preventDefault();
                        setIsPopupStockTransferOpen(true);
                      }}
                      className="cursor-pointer px-4 py-3 whitespace-nowrap underline text-[#005A9C]"
                    >
                      {row.stocks}
                    </td>
                    <td
                      onClick={() => {
                        let redirectState = {
                          path: "/suggested-strategies",
                          state: {
                            from: location.pathname,
                            historyStack: [
                              ...(location.state?.historyStack || []),
                              location.pathname,
                            ],
                          },
                        };
                        sessionStorage.setItem(
                          "redirectAfterLogin",
                          JSON.stringify(redirectState)
                        );
                        navigate("/suggested-strategies", {
                          state: {
                            from: location.pathname,
                            historyStack: [
                              ...(location.state?.historyStack || []),
                              location.pathname,
                            ],
                          },
                        });
                      }}
                      className="cursor-pointer underline px-4 py-3 whitespace-nowrap font-semibold text-emerald-600"
                    >
                      {row.strategies}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan={4}
                    className="px-4 py-4 text-center text-gray-500"
                  >
                    No results found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        {isPopupStockTransferOpen && (
          <ViewAccessRequestPopup
            isView={true}
            onClose={() => setIsPopupStockTransferOpen(false)}
          />
        )}
        {/* Pagination */}
        {!isLoading && (
          <div className="flex flex-col sm:flex-row justify-between items-center mt-4 text-gray-700 text-xs gap-3">
            <div>
              Showing {showRecords * (currentPage - 1) + 1} to{" "}
              {currentPage === totalPages || totalPages === 0
                ? totalCount
                : Math.min(showRecords * currentPage, totalCount)}{" "}
              of {totalCount} entries
            </div>
            <div className="flex gap-1">
              <button
                disabled={currentPage === 1}
                onClick={() => setCurrentPage((prev) => prev - 1)}
                className="px-2.5 py-1 rounded bg-gray-100 hover:bg-gray-200 disabled:opacity-50"
              >
                Prev
              </button>
              {Array.from({ length: Math.min(totalPages, 5) }).map((_, i) => {
                const startPage = Math.max(
                  1,
                  Math.min(totalPages - 4, currentPage - 2)
                );
                const page = startPage + i;
                return (
                  <button
                    key={page}
                    onClick={() => setCurrentPage(page)}
                    className={`px-2.5 py-1 rounded ${
                      currentPage === page
                        ? "bg-indigo-600 text-white font-semibold"
                        : "bg-white border border-gray-300 hover:bg-gray-100"
                    }`}
                  >
                    {page}
                  </button>
                );
              })}
              <button
                disabled={currentPage === totalPages || totalPages === 0}
                onClick={() => setCurrentPage((prev) => prev + 1)}
                className="px-2.5 py-1 rounded bg-gray-100 hover:bg-gray-200 disabled:opacity-50"
              >
                Next
              </button>
            </div>
          </div>
        )}
      </div>
      <div className="font-medium bg-white mt-6 p-4 rounded-xl shadow-sm border border-gray-200 text-sm text-gray-900">
        {/* Header Section */}
        <div className="flex flex-col md:flex-row md:items-center justify-between mb-4 gap-4">
          <h3 className="text-base font-semibold text-black flex items-center gap-2">
            {/* Replace with any SVG above */}
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-6 h-6 text-black"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M12 3l8 4v5c0 5.25-3.25 9.75-8 11-4.75-1.25-8-5.75-8-11V7l8-4zm0 8a2 2 0 110 4 2 2 0 010-4zm0 0v1m0 4v.01"
              />
            </svg>
            Access Requests
          </h3>

          <div className="flex flex-col sm:flex-row sm:items-center gap-3">
            {/* Show Records */}
            <div className="flex items-center gap-2">
              <span className="text-gray-600">Show</span>
              <Dropdown
                label=""
                options={filterOptions}
                preselectedValue={preSelectedFilterAccess}
                onSelect={handleshowRecordAccess}
              />
            </div>

            {/* Search */}
            <div className="relative w-full sm:w-auto">
              <input
                type="text"
                className="pl-9 pr-3 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-2 focus:ring-black focus:outline-none w-full sm:w-60 text-sm"
                placeholder="Search..."
                value={searchQueryAccess}
                onChange={(e) => {
                  setCurrentPage(1);
                  setSearchQueryAccess(e.target.value);
                }}
              />
              <img
                src="/search-normal.svg"
                alt="Search"
                className="absolute left-3 top-2 w-4 h-4 text-gray-400"
              />
            </div>
          </div>
        </div>

        {/* Table */}
        <div className="overflow-x-auto">
          <table className="min-w-full border-separate border-spacing-y-1 text-sm">
            <thead className="bg-gray-100 text-gray-700">
              <tr>
                {portfolioRequestheaders.map((header) => (
                  <th
                    key={header.label}
                    onClick={() => handleSort(header.key)}
                    className="px-4 py-2 text-left font-medium cursor-pointer whitespace-nowrap"
                  >
                    <div className="flex items-center space-x-1">
                      <span>{header.label}</span>
                      {header.key != "" && (
                        <img src="/sort.svg" alt="Icon" class="w-4 h-4 ml-2" />
                      )}
                    </div>
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {isLoadingAccess ? (
                [...Array(5)].map((_, i) => (
                  <tr
                    key={i}
                    className="rounded border border-gray-100 bg-white"
                  >
                    {[...Array(4)].map((_, j) => (
                      <td key={j} className="px-4 py-3">
                        <div className="h-3 bg-gray-200 rounded animate-pulse"></div>
                      </td>
                    ))}
                  </tr>
                ))
              ) : portfolioAccounttableData.length > 0 ? (
                portfolioAccounttableData.map((row, index) => (
                  <tr
                    key={index}
                    className={`transition-colors border border-gray-100 ${
                      index % 2 === 0 ? "bg-white" : "bg-gray-50"
                    } hover:bg-indigo-50`}
                  >
                    <td className="px-4 py-3 whitespace-nowrap">{row.date}</td>
                    <td className="px-4 py-3 whitespace-nowrap">
                      {row.hin_number}
                    </td>
                    <td className="px-4 py-3 whitespace-nowrap">
                      {row.customer_name}
                    </td>
                    <td
                      onClick={() => {
                        dispatch(setInvestmentId(row.id));
                        let redirectState = {
                          path: "/investment-details-by-id",
                          state: {
                            from: location.pathname,
                            historyStack: [
                              ...(location.state?.historyStack || []),
                              location.pathname,
                            ],
                          },
                        };
                        sessionStorage.setItem(
                          "redirectAfterLogin",
                          JSON.stringify(redirectState)
                        );
                        navigate("/investment-details-by-id", {
                          state: {
                            from: location.pathname,
                            historyStack: [
                              ...(location.state?.historyStack || []),
                              location.pathname,
                            ],
                          },
                        });
                      }}
                      className="px-4 py-2 underline cursor-pointer overflow-hidden w-[400px] overflow-hidden text-ellipsis  leading-tight"
                    >
                      <span class="block">
                        Caprock Model Portfolio - Caprock Funds Management Pty
                        Ltd Multi-Asset SMA Aggressive (100/0)
                      </span>
                    </td>
                    <td
                      onClick={(e) => {
                        e.preventDefault();
                        setIsPopupStockOpen(true);
                      }}
                      className="cursor-pointer px-4 py-3 whitespace-nowrap underline text-[#005A9C]"
                    >
                      {row.stocks}
                    </td>
                    <td className="px-4 py-3 whitespace-nowrap relative">
                      <div className="flex items-center gap-2">
                        {/* Status Pill */}
                        <span
                          className={`
        text-xs font-medium px-3 py-1 rounded-full
        ${
          row.status === "approved"
            ? "bg-emerald-100 text-emerald-700"
            : row.status === "rejected"
            ? "bg-rose-100 text-rose-700"
            : "bg-yellow-100 text-yellow-800"
        }
      `}
                        >
                          {row.status.charAt(0).toUpperCase() +
                            row.status.slice(1)}
                        </span>

                        {/* Action Dropdown Trigger */}
                        {row.status === "pending" && (
                          <button
                            onClick={(e) => {
                              e.preventDefault();
                              setIsPopupOpen(true); // You can use this to track which row is being updated
                            }}
                            className="text-sm text-blue-600 hover:underline focus:outline-none"
                          >
                            Change
                          </button>
                        )}
                      </div>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan={4}
                    className="px-4 py-4 text-center text-gray-500"
                  >
                    No results found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        {isPopupOpen && (
          <ViewAccessRequestPopup
            isView={false}
            onClose={() => setIsPopupOpen(false)}
          />
        )}
        {isPopupStockOpen && (
          <ViewAccessRequestPopup
            isView={true}
            onClose={() => setIsPopupStockOpen(false)}
          />
        )}
        {/* Pagination */}
        {!isLoadingAccess && (
          <div className="flex flex-col sm:flex-row justify-between items-center mt-4 text-gray-700 text-xs gap-3">
            <div>
              Showing {showRecordsAccess * (currentPageAccess - 1) + 1} to{" "}
              {currentPageAccess === totalPagesAccess || totalPagesAccess === 0
                ? totalCountAccess
                : Math.min(
                    showRecordsAccess * currentPageAccess,
                    totalCountAccess
                  )}{" "}
              of {totalCountAccess} entries
            </div>
            <div className="flex gap-1">
              <button
                disabled={currentPageAccess === 1}
                onClick={() => setCurrentPageAccess((prev) => prev - 1)}
                className="px-2.5 py-1 rounded bg-gray-100 hover:bg-gray-200 disabled:opacity-50"
              >
                Prev
              </button>
              {Array.from({ length: Math.min(totalPagesAccess, 5) }).map(
                (_, i) => {
                  const startPage = Math.max(
                    1,
                    Math.min(totalPagesAccess - 4, currentPageAccess - 2)
                  );
                  const page = startPage + i;
                  return (
                    <button
                      key={page}
                      onClick={() => setCurrentPageAccess(page)}
                      className={`px-2.5 py-1 rounded ${
                        currentPage === page
                          ? "bg-indigo-600 text-white font-semibold"
                          : "bg-white border border-gray-300 hover:bg-gray-100"
                      }`}
                    >
                      {page}
                    </button>
                  );
                }
              )}
              <button
                disabled={
                  currentPageAccess === totalPagesAccess ||
                  totalPagesAccess === 0
                }
                onClick={() => setCurrentPageAccess((prev) => prev + 1)}
                className="px-2.5 py-1 rounded bg-gray-100 hover:bg-gray-200 disabled:opacity-50"
              >
                Next
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default InspecieTransferRequest;
